export default __webpack_public_path__ + "static/media/logo40.3cf6640b.png";